module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "forgot-password"
    }
  }, [_c('div', {
    staticClass: "page animation vertical-align text-center forgot-your-pass",
    attrs: {
      "data-animation-in": "fade-in",
      "data-animation-out": "fade-out"
    }
  }, [_c('div', {
    staticClass: "page-content vertical-align-middle",
    staticStyle: {
      "display": "block"
    }
  }, [_vm._m(0), _vm._v(" "), (!_vm.showSuccessMsg) ? _c('form', {
    attrs: {
      "id": "reset-password-wrapper"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onResetPassword.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "login-page-title"
  }, [_vm._v("\n                    Forgot your Password?\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "login-page-description"
  }, [_vm._v("\n                    Please enter your registered email address below to start your password reset.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "reset-password-form"
  }, [_c('div', {
    staticClass: "form-group form-material inp-error-marker"
  }, [_c('v-input-text', {
    attrs: {
      "type": _vm.text,
      "label": 'EMAIL',
      "placeholder": 'Email',
      "value": _vm.firstName,
      "required": true,
      "showError": _vm.validation.forEmail,
      "errorMessage": _vm.emailErrorMsg
    },
    on: {
      "input": function (val) { return (_vm.email = val); },
      "focus": function($event) {
        _vm.validation.forEmail = false
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "friendly-captcha"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(!_vm.resetPasswordSubmited) ? _c('button', {
    staticClass: "btn btn-success btn-block login-btn",
    attrs: {
      "id": "reset-pass-btn",
      "type": "submit",
      "disabled": _vm.isDisabled
    }
  }, [_vm._v("RESET YOUR PASSWORD")]) : _vm._e(), _vm._v(" "), (_vm.resetPasswordSubmited) ? _c('button', {
    staticClass: "btn btn-success btn-block login-btn",
    attrs: {
      "id": "reset-pass-btn-loader",
      "type": "button",
      "hidden": ""
    }
  }, [_c('img', {
    staticClass: "loader-icon-gif",
    staticStyle: {
      "margin-top": "-40px"
    },
    attrs: {
      "src": "/Assets/loader.gif"
    }
  })]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.showSuccessMsg) ? _c('div', {
    attrs: {
      "id": "reset-password-success-msg"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "login-page-title password-changed"
  }, [_vm._v("\n                    Please check your inbox!\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "login-page-description password-changed"
  }, [_vm._v("\n                    If we found an account associated with your email address you should receive an email shortly with further instructions.\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "login-page-description password-changed"
  }, [_vm._v("\n                    If the email is not in your inbox please make sure to check your spam folder. Thanks!\n                ")])]) : _vm._e(), _vm._v(" "), _vm._m(2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('a', {
    attrs: {
      "href": "http://www.trackado.com"
    }
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "/Assets/landing/logo-landing.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "check-inbox"
  }, [_c('img', {
    attrs: {
      "src": "/Assets/landing/icon-mail.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "friendly-captcha-forgot-pass"
  }, [_c('p', [_vm._v("This site is protected by "), _c('a', {
    attrs: {
      "href": "https://friendlycaptcha.com/",
      "target": "_blank"
    }
  }, [_vm._v("Friendly Captcha")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-4e4e0021!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./modules/forgot-password/ForgotPassword.vue
// module id = 2677
// module chunks = 40